module.exports = __webpack_public_path__ + "static/media/clal-logo.0d6ca13b.png";